import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, levelMap} from 'utils/common';

class AwardForm extends React.Component {
  render() {
    const {isUpdate, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <Field name="title" label="Title" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          <Col md={6}>
            <Field
              name="points"
              label="Points"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isSafePositiveInteger]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="level"
              label="Level"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              options={[
                {value: 1, label: 'Yellow'},
                {value: 2, label: 'Green'},
                {value: 3, label: 'Orange'},
              ]}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={12}>
            <Field
              id="image"
              name="image"
              label="Select Award Image"
              component={fields.FileField}
              required={!isUpdate}
              validate={isUpdate ? undefined : [validators.isRequired]}
            />
          </Col>
          <Col md={12}>
            <Field id="game" name="game" label="Select Award Game" accept="*/*" component={fields.FileField} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const currentAward = state.awards.get('currentAward').toJS();
  return {
    isUpdate: true,
    initialValues: {
      ...currentAward,
      level: {value: currentAward.level, label: levelMap[currentAward.level]},
    },
  };
};

export default {
  Creation: makeForm(AwardForm, 'AwardForm.Creation', null, null),
  Update: makeForm(AwardForm, 'AwardForm.Update', mapStateToProps, null),
};
